export default __webpack_public_path__ + "static/media/SubinAdhikari-removebg-preview.aea7d101.png";